if (!customElements.get('cm-new-product-gallery')) {
  customElements.define('cm-new-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryEvents) return;
      this.galleryEvents = new AbortController();
      const signal = this.galleryEvents.signal;
      // Deferred script runs after initial markup; later editor insertions upgrade
      // after their children have been inserted. Delegate events to this gallery.
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.setAttribute('role', 'button');
      });
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        event.preventDefault();
        this.swapImage(thumb);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb || event.key !== ' ') return;
        event.preventDefault();
        this.swapImage(thumb);
      }, { signal });
    }

    disconnectedCallback() {
      this.galleryEvents?.abort();
      this.galleryEvents = null;
    }

    swapImage(thumb) {
      const main = this.querySelector('[data-gallery-main]');
      const previousImage = main?.querySelector('img');
      const nextImage = thumb.querySelector('img');
      if (!previousImage || !nextImage) return;
      const previousIndex = main.dataset.index;
      const nextIndex = thumb.dataset.index;
      nextImage.sizes = this.dataset.mainSizes;
      nextImage.loading = 'eager';
      previousImage.sizes = '120px';
      previousImage.loading = 'lazy';
      // Move the actual image nodes, retaining their focal points and alt text.
      // The focused thumbnail remains the same control; the first image can
      // always be selected again, even when only two images were registered.
      main.replaceChildren(nextImage);
      thumb.replaceChildren(previousImage);
      main.dataset.index = nextIndex;
      thumb.dataset.index = previousIndex;
      thumb.setAttribute('aria-label', `${this.dataset.productTitle || previousImage.alt} — ${this.dataset.showLabel.replace('__NUMBER__', previousIndex)}`);
      const status = this.querySelector('[data-gallery-status]');
      if (status) status.textContent = this.dataset.statusLabel.replace('__NUMBER__', nextIndex);
    }
  });
}
